<nav class="pagination-container">
  <span class="page-input">
    <span class="goto-label">Go To Page</span>
    <input type="number" [value]="page" (keyup.enter)="goToPage($event)" min="1" [max]="totalPages">
  </span>
  @for (p of pages; track p) {
    <button (click)="changePage(p)" [class.active]="p === page">
      {{ p }}
    </button>
  }

  <button (click)="changePage(page + 1)" class="icon-button" [disabled]="page === totalPages"><span
    class="next-label">Next</span><mat-icon>chevron_right</mat-icon></button>

  </nav>